import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 3h3v18h-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 21H5V3h3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Brackets";
const Brackets = memo(themed(Icon));
export {
  Brackets
};
//# sourceMappingURL=brackets.js.map
